<template>
	<v-row class="text-center d-flex align-center" no-gutters>
		<home-view />
		<v-overlay :value="ticketsLoading" :absolute="true">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-row>
</template>
<script>
import api from '../api/api';
import HomeView from './HomeView.vue';
export default {
	components: { HomeView },

	data: () => ({
		ticketsLoading: false
	}),

	methods: {
		handleDownloadTickets({ purchaseReference }) {
			this.ticketsLoading = true;
			return api.externalSale
				.downloadTickets({ id: purchaseReference })
				.then((res) => {
					const link = document.createElement('a');
					// create a blobURI pointing to our Blob
					link.href = URL.createObjectURL(res.data);
					link.download = 'Tickets.zip';
					// some browser needs the anchor to be in the doc
					document.body.append(link);
					link.click();
					link.remove();
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.ticketsLoading = false;
				});
		}
	},
	beforeRouteEnter(to, from, next) {
		const params = to.params;
		next((vm) => {
			vm.handleDownloadTickets(params);
		});
	},
	mounted() {}
};
</script>

<style></style>
